import { registerComponentInterceptor } from '../componentInterceptor';
import { default as React } from 'react';

/**
 * Register this component as an override for the View graph link on
 * the Application Diagram.
 * @param _originalElement - Props for the jsx element
 */
export const CustomApplicationDiagram = (_originalElement: any) => {
  return <></>;
};

registerComponentInterceptor({
  canIntercept(_type: React.ElementType, props: any, _key: React.Key) {
    return /catalog-graph\?rootEntityRefs.*system.*/.test(props?.to)
      ? true
      : false;
  },
  performIntercept() {
    return {
      element: <></>,
    };
  },
});
